<!-- Mobile: a single "up one level" link, since the full trail is hidden below sm. -->
@if (backCrumb$ | async; as backCrumb) {
    <a
        class="text-primary-500 hover:text-primary-700 flex min-w-0 items-center font-medium hover:underline sm:hidden"
        [routerLink]="backCrumb.url"
    >
        <mat-icon
            class="icon-size-4 mr-1 flex-0"
            [svgIcon]="'heroicons_mini:arrow-left'"
        ></mat-icon>
        <span class="truncate">{{ backCrumb.label }}</span>
    </a>
}

@if (breadcrumbs$ | async; as breadcrumbs) {
    <nav
        class="hidden min-w-0 items-center font-medium sm:flex"
        aria-label="Breadcrumb"
    >
        @for (breadcrumb of breadcrumbs; track $index; let last = $last) {
            <div class="flex min-w-0 items-center">
                <!-- The last crumb is the current page, so it is text rather than a link. -->
                @if (last) {
                    <span
                        class="text-secondary truncate"
                        aria-current="page"
                        >{{ breadcrumb.label }}</span
                    >
                } @else {
                    <a
                        class="text-primary-500 hover:text-primary-700 truncate hover:underline"
                        [routerLink]="breadcrumb.url"
                        >{{ breadcrumb.label }}</a
                    >
                    <mat-icon
                        class="icon-size-4 text-hint mx-1 flex-0"
                        [svgIcon]="'heroicons_mini:chevron-right'"
                    ></mat-icon>
                }
            </div>
        }
    </nav>
}
